import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  Signal,
  inject,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AuthUser } from 'projects/shared/src/lib/auth/auth/data-access/auth.service';
import { HeaderFooterElements } from '@shared-interfaces/shared-header-footer';

@Component({
  selector: 'shared-header-menu',
  standalone: true,
  imports: [MatIconModule, MatButtonModule, MatMenuModule, CommonModule],
  templateUrl: './header-menu.component.html',
  styleUrl: './header-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderMenuComponent {
  @Input() headerMenuElements: HeaderFooterElements | undefined = undefined;
  @Input() user: AuthUser;
  @Output() headerNavigationEvent: EventEmitter<string> =
    new EventEmitter<string>();

  emitNavigationEvent(path: string | { [key: string]: string }): void {
    if (typeof path === 'string') {
      this.headerNavigationEvent.emit(path);
    }
  }
}
